import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
// import { makeStyles } from '@material-ui/core/styles';

const TextFormControl = (props) => {
  const [value, setValue] = useState(props.formData || '');

  const onChange = (event) => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <TextField
      required={props.required}
      id={props.idSchema.$id}
      type={
        (props.uiSchema['ui:options'] &&
          props.uiSchema['ui:options'].inputType) ||
      'text'
      }
      label={props.schema.title}
      placeholder={props.schema.placeholder}
      onChange={onChange}
      fullWidth
      value={value}
      InputLabelProps={{
        shrink: true
      }}
      variant={
        (props.uiSchema['ui:options'] &&
          props.uiSchema['ui:options'].variant) ||
      'standard'
      }
      multiline={
        (props.uiSchema['ui:options'] &&
          props.uiSchema['ui:options'].multiline) ||
      false
      }
      rows={
        (props.uiSchema['ui:options'] &&
          props.uiSchema['ui:options'].multiline &&
          '4') ||
      '1'
      }
    />
  );
};

export default TextFormControl;
